import styled from "styled-components";

export const CreatePage = styled.div`
  width: 100%;
  min-width: 0;
  padding: 16px;
  background: #f8fafc;

  @media (max-width: 767px) {
    padding: 8px;
  }
`;

export const CreateHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin: 0 0 24px;

  @media (max-width: 767px) {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .ant-typography {
    margin: 0;
  }
`;

export const HeaderIdentity = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  min-width: 0;
  gap: 12px;

  .ant-typography {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    width: 100%;

    .ant-btn {
      flex: 1 1 0;
    }
  }
`;

export const FormPanel = styled.div`
  min-width: 0;
  width: 100%;
  margin: 0;
`;

export const FormCard = styled.div`
  padding: 24px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;

  @media (max-width: 767px) {
    padding: 16px;
  }
`;

export const FormColumns = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  width: 100%;

  .contract-request-column {
    min-width: 0;
  }

  .contract-request-column:first-child {
    padding-right: 24px;
    border-right: 1px solid #e5e7eb;
  }

  .contract-request-column:last-child {
    padding-left: 24px;
  }

  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);

    .contract-request-column:first-child {
      padding-right: 0;
      border-right: 0;
    }

    .contract-request-column:last-child {
      padding-left: 0;
    }
  }
`;
